import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { AuthService } from 'src/app/api/auth.service';
import { ChartLayoutService } from 'src/app/services/chart-layout.service';

@Component({
    selector: 'auth-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.auth.logout();

    let proChartLayoutData = window.localStorage.getItem(ChartLayoutService.CHART_LAYOUT_DATA_KEY);

    // Clear local storage
    window.localStorage.clear();

    localStorage.setItem(ChartLayoutService.CHART_LAYOUT_DATA_KEY, proChartLayoutData);

    timer(1000).subscribe(() => {
      this.router.navigate(['/home']);
    });
  }

}
